export default __webpack_public_path__ + "img/logo-roche-bleu.9d99d005.svg";